import { useEffect, useCallback } from 'react';
import { useGoogleReCaptcha } from 'react-google-recaptcha-v3';

function AhabReCaptchaComponent(props) {
  const { executeRecaptcha } = useGoogleReCaptcha();

  const handleReCaptchaVerify = useCallback(async () => {
    if (!executeRecaptcha) {
      window.grecaptcha = undefined;
      return;
    }

    await executeRecaptcha('talentSignup')
      .then(token => {
        props.func(token);
      })
      .catch(_ => {
        // Known issue with react-google-recaptcha-v3 and routes; force a reload to fix. https://github.com/t49tran/react-google-recaptcha-v3/issues/192
        window.location.reload();
      });
    //eslint-disable-next-line react-hooks/exhaustive-deps
  }, [executeRecaptcha]);

  // Use useEffect to trigger the verification as soon as the component being loaded
  useEffect(() => {
    handleReCaptchaVerify();
  }, [handleReCaptchaVerify]);

  return null;
}
export default AhabReCaptchaComponent;
